import { EnvironmentFeatureFlagStateDto } from '@flagsync/skyline';

export const featureFlagStates: EnvironmentFeatureFlagStateDto[] = [
  {
    featureFlagEnvironmentStateId: 1,
    featureFlag: {
      featureFlagId: 101,
      publicFeatureFlagId: '0x1',
      name: 'Enable OAuth',
      key: 'enable_oauth',
      description: 'Enable OAuth authentication mechanism.',
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-02T00:00:00Z',
      variants: [
        {
          variantId: 1,
          dataTypeCode: 'BOOL',
          name: 'Enabled',
          description: 'Default variant',
          createdAt: '2025-01-01T00:00:00Z',
          updatedAt: '2025-01-01T00:00:00Z',
          booleanValue: true,
          jsonValue: {},
          numberValue: 0,
          stringValue: '',
        },
        {
          variantId: 2,
          dataTypeCode: 'BOOL',
          name: 'Disabled',
          description: 'Default variant',
          createdAt: '2025-01-01T00:00:00Z',
          updatedAt: '2025-01-01T00:00:00Z',
          booleanValue: false,
          jsonValue: {},
          numberValue: 0,
          stringValue: '',
        },
      ],
    },
    environmentId: 1,
    isEnabled: false,
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-02T00:00:00Z',
    enabledSingleVariantId: 1,
    disabledSingleVariantId: 2,
    targetedVariantIds: [],
    isPercentageRollout: false,
    isTargetedRollout: false,
    hasActiveExperiment: false,
  },
  {
    featureFlagEnvironmentStateId: 3,
    featureFlag: {
      featureFlagId: 103,
      publicFeatureFlagId: '0x2',
      name: 'New Checkout',
      key: 'new-checkout',
      description: 'Enable the new checkout flow.',
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-02T00:00:00Z',
      variants: [
        {
          variantId: 2,
          dataTypeCode: 'BOOL',
          name: 'Enabled',
          description: 'Enable the new checkout flow.',
          createdAt: '2025-01-01T00:00:00Z',
          updatedAt: '2025-01-01T00:00:00Z',
          booleanValue: true,
          jsonValue: {},
          numberValue: 0,
          stringValue: '',
        },
        {
          variantId: 3,
          dataTypeCode: 'BOOL',
          name: 'Disabled',
          description: 'Enable the new checkout flow.',
          createdAt: '2025-01-01T00:00:00Z',
          updatedAt: '2025-01-01T00:00:00Z',
          booleanValue: false,
          jsonValue: {},
          numberValue: 0,
          stringValue: '',
        },
      ],
    },
    environmentId: 2,
    isEnabled: false,
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-02T00:00:00Z',
    enabledSingleVariantId: 2,
    disabledSingleVariantId: 3,
    targetedVariantIds: [],
    isPercentageRollout: true,
    isTargetedRollout: false,
    hasActiveExperiment: false,
  },
  {
    featureFlagEnvironmentStateId: 2,
    featureFlag: {
      featureFlagId: 102,
      publicFeatureFlagId: '0x3',
      name: 'Register CTA',
      key: 'register-cta',
      description: 'Change the CTA copy on registration page.',
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-02T00:00:00Z',
      variants: [
        {
          variantId: 1,
          dataTypeCode: 'STR',
          name: 'Register',
          description: 'Default registration CTA copy.',
          createdAt: '2025-01-01T00:00:00Z',
          updatedAt: '2025-01-01T00:00:00Z',
          booleanValue: false,
          jsonValue: {},
          numberValue: 0,
          stringValue: 'Register Now',
        },
        {
          variantId: 2,
          dataTypeCode: 'STR',
          name: 'Sign Up',
          description: 'Default registration CTA copy.',
          createdAt: '2025-01-01T00:00:00Z',
          updatedAt: '2025-01-01T00:00:00Z',
          booleanValue: false,
          jsonValue: {},
          numberValue: 0,
          stringValue: 'Register Now',
        },
        {
          variantId: 3,
          dataTypeCode: 'STR',
          name: 'Join Now',
          description: 'Default registration CTA copy.',
          createdAt: '2025-01-01T00:00:00Z',
          updatedAt: '2025-01-01T00:00:00Z',
          booleanValue: false,
          jsonValue: {},
          numberValue: 0,
          stringValue: 'Register Now',
        },
      ],
    },
    environmentId: 1,
    isEnabled: true,
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-02T00:00:00Z',
    enabledSingleVariantId: 1,
    disabledSingleVariantId: 1,
    // @ts-expect-error -- mock data
    targetedVariantIds: [1, 2, 3],
    isPercentageRollout: true,
    isTargetedRollout: true,
    hasActiveExperiment: false,
  },
  {
    featureFlagEnvironmentStateId: 5,
    featureFlag: {
      featureFlagId: 105,
      publicFeatureFlagId: '0x4',
      name: 'Dark Mode',
      key: 'dark-mode',
      description: 'Enable dark mode for the application.',
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-02T00:00:00Z',
      variants: [
        {
          variantId: 5,
          dataTypeCode: 'BOOL',
          name: 'Enabled',
          description: 'Enable dark mode variant.',
          createdAt: '2025-01-01T00:00:00Z',
          updatedAt: '2025-01-01T00:00:00Z',
          booleanValue: true,
          jsonValue: {},
          numberValue: 0,
          stringValue: '',
        },
        {
          variantId: 6,
          dataTypeCode: 'BOOL',
          name: 'Disabled',
          description: 'Enable dark mode variant.',
          createdAt: '2025-01-01T00:00:00Z',
          updatedAt: '2025-01-01T00:00:00Z',
          booleanValue: false,
          jsonValue: {},
          numberValue: 0,
          stringValue: '',
        },
      ],
    },
    environmentId: 1,
    isEnabled: true,
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-02T00:00:00Z',
    enabledSingleVariantId: 5,
    disabledSingleVariantId: 6,
    targetedVariantIds: [],
    isPercentageRollout: false,
    isTargetedRollout: false,
    hasActiveExperiment: false,
  },
  {
    featureFlagEnvironmentStateId: 4,
    featureFlag: {
      featureFlagId: 104,
      publicFeatureFlagId: '0x5',
      name: 'Product Discount',
      key: 'product-discount',
      description: 'Enable fullscreen mode for better user experience.',
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-02T00:00:00Z',
      variants: [
        {
          variantId: 1,
          dataTypeCode: 'NUM',
          name: '0%',
          description: 'Default registration CTA copy.',
          createdAt: '2025-01-01T00:00:00Z',
          updatedAt: '2025-01-01T00:00:00Z',
          booleanValue: false,
          jsonValue: {},
          numberValue: 0,
          stringValue: '',
        },
        {
          variantId: 2,
          dataTypeCode: 'NUM',
          name: '10%',
          description: 'Default registration CTA copy.',
          createdAt: '2025-01-01T00:00:00Z',
          updatedAt: '2025-01-01T00:00:00Z',
          booleanValue: false,
          jsonValue: {},
          numberValue: 0.1,
          stringValue: '',
        },
        {
          variantId: 3,
          dataTypeCode: 'NUM',
          name: '25%',
          description: 'Default registration CTA copy.',
          createdAt: '2025-01-01T00:00:00Z',
          updatedAt: '2025-01-01T00:00:00Z',
          booleanValue: false,
          jsonValue: {},
          numberValue: 0.25,
          stringValue: '',
        },
      ],
    },
    environmentId: 2,
    isEnabled: true,
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-02T00:00:00Z',
    enabledSingleVariantId: 2,
    disabledSingleVariantId: 1,
    // @ts-expect-error -- mock data
    targetedVariantIds: [2, 3],
    isPercentageRollout: true,
    isTargetedRollout: false,
    hasActiveExperiment: false,
  },
];
